import { render } from "./ModalConfirmDuplicateCustomer.vue?vue&type=template&id=398748ac&scoped=true"
import script from "./ModalConfirmDuplicateCustomer.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDuplicateCustomer.vue?vue&type=script&lang=js"

import "./styles/ModalSearchPostalCode.scss?vue&type=style&index=0&id=398748ac&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398748ac"]])

export default __exports__